import { Injectable, inject } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { TranslationService } from '../services/translation-service';
import { SessionService } from '../auth/session-service';

@Injectable({
  providedIn: 'root',
})
export class LoginGuard implements CanActivate {
  private readonly router = inject(Router);
  private translationService = inject(TranslationService);
  private translateService = inject(TranslateService);
  private sessionService = inject(SessionService);

  canActivate(): boolean | UrlTree {
    const urlLang = this.translationService.currentLangOnStandard(this.translateService);
    if (this.sessionService.isAppAuthenticated()) {
      return this.router.createUrlTree([`/${urlLang}/home`]);
    }

    return true;
  }
}
